import React from 'react'
import {PersianNumber} from 'react-persian'

class ShopReport extends React.Component {
  render () {
    const {items, products} = this.props
    return (
      <p>
        در حال حاضر
        <ul>
          {products.map((product, index) => (
            <li key={index}><PersianNumber>{items[`p_${product.id}`]}</PersianNumber> {product.title} به قیمت <PersianNumber>{(product.price * items[`p_${product.id}`]).toLocaleString()}</PersianNumber> تومان</li>
        ))}
        </ul>

        <span>قابل پرداخت: </span>{' '}
        <strong>
          <PersianNumber>{products.reduce((total, product) => (total + (product.price * items[`p_${product.id}`])), 0).toLocaleString()}</PersianNumber>
        </strong>
      </p>
    )
  }
}

ShopReport.propTypes = {
  items: React.PropTypes.object,
  products: React.PropTypes.array
}

export default ShopReport



// WEBPACK FOOTER //
// ./src/components/Donate/ShopReport.js